module.exports = __webpack_public_path__ + "img/bit_withdraw_icon.ebebc069.svg";